import React from 'react'

import { useStoreContext } from 'hooks/StoreContext'
import useNexiaStream from 'hooks/useNexiaStream'

import { DeviceBase } from 'types/Device'

type Props = {
  device: DeviceBase
}

const ZoneStatus = ({ device }: Props) => {
  const { reportCache } = useStoreContext()
  const { eventData: report } = useNexiaStream(device.deviceId, 'current_status', reportCache)

  const zoningEnabled = report ? report.zones?.length > 1 : device.zoningEnabled

  return <span><b>{zoningEnabled ? 'Zoned' : 'Non-Zoned'}</b></span>
}

export default ZoneStatus
